import React from "react";
import { GlobalMessageContext } from "./GlobalMessageSnackbar";

/*
 * This hook abstracts the React context (Consumer) that controls the MUI Snackbar.
 * It is intended to be used with `withGlobalMessage` HOC, which abstracts the Provider of React Context
 * USAGE
 *
 * 1. Wrap the component in `withGlobalMessage`
 * 2. Access the methods on the GlobalMessageContext
 *
 * function Component () {
 *      const { showGlobalMessage } = useGlobalMessage();
 *      showGlobalMessage("An error has occurred", "error");
 *      showGlobalMessage("Listing moved", "success");
 * }
 *
 * export default withGlobalMessage(Component);
 *
 */
export default function useGlobalMessage() {
  var context = React.useContext(GlobalMessageContext);
  if (context === undefined) {
    throw new Error("useGlobalMessage must be used within a GlobalMessageContextProvider. See `useGlobalMessages.tsx` for usage");
  }
  return context;
}